export const transformExamplesToTable = (examples: any[] = [], showRowNumber = true) => {
  if (examples.length === 0) return { columns: [], data: [] };

  const dataKeys = Object.keys(examples[0].data);

  const columns = [
    ...(showRowNumber
      ? [{ key: "row_number", header: "Row Number" }]
      : []),
    ...dataKeys.map((key) => ({
      key,
      header: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    })),
  ];

  const data = examples.map((item) => ({
    row_number: item.row_number,
    ...item.data,
  }));

  return { columns, data };
};
